module.exports = __webpack_public_path__ + "static/img/_N2E5433-1080p.6d64e8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio5/_N2E5433-1080p.jpg
// module id = DThJ
// module chunks = 0